import React from "react";
import PrivavcyBg from "../assets/img/privavcy-bg.jpg";
import { Link } from "react-router-dom";

const PrivavcyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Title Area */}
      <div
        className="relative h-[500px] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${PrivavcyBg})` }}
      >
        {/* Optional dark overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        {/* Text on top */}
        <div className="relative z-20 container mx-auto px-4 h-full flex flex-col justify-center items-center text-white text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Privacy Policy
          </h1>
          <nav className="flex justify-center items-center space-x-2 text-sm">
            <Link to="/" className="hover:text-blue-300 transition-colors">
              Home
            </Link>
            <span className="text-gray-300">/</span>
            <span className="text-gray-300">Privacy Policy</span>
          </nav>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h3 className="mt-0 text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-500 pb-3">
          We are committed to protecting your privacy
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          Your privacy is precious and matters to us. Therefore, we do not sell,
          forward or rent your personal information what you share with Elenoit
          Digital Solution Pvt. Ltd. (hereafter, called as Elenoit), to any
          third party for any purposes like marketing etc. without your explicit
          consent.
        </p>
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          We gather the minimum amount of information about you for providing
          you with a satisfactory service. This policy indicates the type of
          processes that may result in data being gathered about you. Your use
          of this website gives us the right to fetch that information.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-500 pb-3">
          Information We Collect and Use
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          We may fetch any or all of the information that you give us depending
          on the type of transaction you enter into, which includes your name,
          address, contact number, and email address, together with data about
          your use of the website. Other information that may be needed with the
          passage of time to process a request may also be gathered as mentioned
          on the website.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          We use the gathered information primarily to process the task for
          which you visited the website. All reasonable precautionary measures
          are taken to avert unauthorised access to this information. This
          protection may oblige you to provide additional forms of identity if
          you wish to obtain information about your account details.
        </p>
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          We may use your Personal Data to contact you with newsletters,
          marketing or promotional materials and other information that may be
          of interest to you. You may opt out of receiving any, or all, of these
          communications from us by following the unsubscribe link or
          instructions provided in any email we send or by contacting us.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-500 pb-3">
          Disclosing Information
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          We do not disclose any personal information obtained about you from
          this website to third parties without your explicit consent by marking
          the relevant boxes in registration, or any relevant forms needed. We
          may also use the information to stay in touch with you and inform you
          of the progress associated with us. You may choose to remove yourself
          from any mailing list or similar device.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          We may occasionally provide information of a general nature to third
          parties – e.g., the number of individuals visiting our website or
          completing a registration form, but we will not use any information
          that could identify those individuals.
        </p>
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          In addition, Elenoit may work with third parties for the purpose of
          delivering targeted behavioural advertising to the Elenoit website.
          Through the use of cookies, anonymous information about your use of
          our websites and other websites will be used to provide more relevant
          adverts about goods and services of interest to you.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-500 pb-3">
          Changes to this Policy
        </h3>
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          Elenoit has the discretion to update this privacy policy at any time.
          Any amendment to our Privacy Policy will be placed here and will
          supersede this version of our policy. We will take reasonable measures
          to draw your attention to the revised policy. We encourage Users to
          read this document each time you use the website to ensure that it
          still meets with your approval and also stay informed about how we are
          helping you to protect the personal information we collect.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-blue-500 pb-3">
          Contacting Us
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          If you have any questions about our Privacy Policy, or if you want to
          know what information we have collected about you, please email us at{" "}
          <a href="mailto:elenoit2021@gmail.com">elenoit2021@gmail.com</a>. You
          can also rectify any factual errors in that information or let us know
          if you want us to remove your details from any list under our control.
        </p>
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          If you are a Client or customer of Elenoit's services or products, you
          will be updated about the changes to this policy, with enough prior
          notice.
        </p>
      </div>
    </div>
  );
};

export default PrivavcyPolicy;
